import { documentToReactComponents } from "@contentful/rich-text-react-renderer"
import React, { useEffect, useState } from "react"
import Slider from "react-slick"
import "slick-carousel/slick/slick-theme.css"
import "slick-carousel/slick/slick.css"
import "./article-steps.scss"

import ArticleAudio from "../article-audio/article-audio"
import { nexArticleDatalayer } from "../../../shared/utils/transversalDatalayer"


const ArticleSteps = props => {
  const { mobile, slugPrefix } = props

  const [nav1, setNav1] = useState(null)
  const [nav2, setNav2] = useState(null)
  const [nav3, setNav3] = useState(null)

  const [currentSlide, setCurrentSlide] = useState(1)

  var slider1
  var slider2
  var slider3

  useEffect(() => {
    setNav1(slider1)
    setNav2(slider2)
    setNav3(slider3)
    return
  })

  var settings1 = {
    // lazyLoad: true,
    // dots: props.mobile ? true : false,
    // infinite: props.mobile ? true : false,
    slidesToShow: props.mobile
      ? 3
      : props.pasos.length > 6
        ? 6
        : props.pasos.length,
    focusOnSelect: true,
    arrows: false,
    // slidesToScroll: 1
  }

  var settings2 = {
    // dots: true,
    infinite: true,
    // speed: 500,
    slidesToShow: 1,
    arrows: false,
    beforeChange: (current, next) => setCurrentSlide(next + 1),
  }

  var settings3 = {
    // dots: true,
    infinite: true,
    // speed: 500,
    slidesToShow: 1,
    fade: true,
    draggable: false,
    arrows: false,
    adaptiveHeight: true,
  }

  const getCountItems = num => {
    if (!mobile) {
      switch (num) {
        case 1:
          return "f-two-items"
        case 2:
          return "f-two-items"
        case 3:
          return "f-three-items"
        case 4:
          return "f-four-items"
        default:
          return ""
      }
    } else {
      return ""
    }
  }

  return (
    <div className="f-article-body">

      <ArticleAudio audioContent={props}/>

      <Slider
        {...settings1}
        ref={slider => (slider1 = slider)}
        className={"f-prev-imgs-slider " + getCountItems(props.pasos.length)}
        asNavFor={nav3}
      >
        {props.pasos.map((paso, index) => {
          return (
            <div className="f-prev-img-container f-two-items" key={index}>
              <img
                className="f-src-img"
                src={paso.imagenDelPaso.file.url}
                alt={paso.imagenDelPaso.description}
              />
            </div>
          )
        })}
      </Slider>
      <div className="f-slider-container">
        <Slider
          {...settings2}
          ref={slider => (slider2 = slider)}
          className="f-active-imgs-slider"
          asNavFor={nav1}
        >
          {props.pasos.map((paso, index) => {
            return (
              <div className="f-active-img-container" key={index}>
                <img
                  className="f-active-src-img"
                  src={paso.imagenDelPaso.file.url}
                  alt={paso.imagenDelPaso.description}
                />
              </div>
            )
          })}
        </Slider>
        <div className="f-next-prev-container">
          <div
            className="f-btn-slide f-prev-btn"
            onClick={() => {
              nav1.slickPrev()
            }}
          >
            <span className="icon-izquierda f-icon" />
          </div>
          <span className="f-current-index">{currentSlide}</span>
          <span className="f-length-slides">{props.pasos.length}</span>
          <div
            className="f-btn-slide f-next-btn"
            onClick={() => {
              nav1.slickNext()
            }}
          >
            <span className="icon-right-arrow f-icon" />
          </div>
        </div>
      </div>

      <div className="f-progress-slide-container">
        <div
          className="f-progress-visual"
          style={{ width: (currentSlide / props.pasos.length) * 100 + "%" }}
        ></div>
      </div>

      <Slider
        {...settings3}
        ref={slider => (slider3 = slider)}
        asNavFor={nav2}
        className="f-description-step-slider"
      >
        {props.pasos.map((paso, index) => {
          return (
            <span className="f-step-description" key={index}>
              {documentToReactComponents(paso.descripcinDelPaso.json)}
            </span>
          )
        })}
      </Slider>

      <div className="f-page-buttons-container">
        {props.prevPag !== null && (
          <a 
            href={slugPrefix + props.prevPag.slug}
            onClick={() => {
              nexArticleDatalayer({label: slugPrefix + props.prevPag.slug, category: 'anterior'})
            }}
          >
            <div className="f-option f-prev-option">
              <span className="f-text-action">Anterior artículo</span>

              <div className="f-icon-action-container f-container-icon-left">
                <span className="f-icon icon-right f-icon-left" />
              </div>
            </div>
          </a>
        )}
        {props.nextPag !== null && (
          <a 
            href={slugPrefix + props.nextPag.slug}
            onClick={() => {
              nexArticleDatalayer({label: slugPrefix + props.nextPag.slug, category: 'siguiente'})
            }}
          >
            <div className="f-option f-next-option">
              <div className="f-icon-action-container ">
                <span className="f-icon icon-right f-icon-right" />
              </div>
              <span className="f-text-action">Siguiente artículo</span>
            </div>
          </a>
        )}
      </div>
    </div>
  )
}

export default ArticleSteps
